import type { ExtractedDataItem } from '../types';

export interface FieldPartitions {
  template: ExtractedDataItem[];
  freeform: ExtractedDataItem[];
  fullPage: ExtractedDataItem[];
}

/**
 * Split a page's extracted fields by where they came from, preserving the
 * incoming order inside each bucket.
 *
 * A field with no `source` is a template field: every result stored before
 * OMA-614 predates the discriminator, and those are all template extractions.
 */
export function partitionFields(fields: ExtractedDataItem[]): FieldPartitions {
  const partitions: FieldPartitions = {
    template: [],
    freeform: [],
    fullPage: []
  };

  for (const field of fields) {
    if (field.source === 'freeform') {
      partitions.freeform.push(field);
    } else if (field.source === 'full_page') {
      partitions.fullPage.push(field);
    } else {
      partitions.template.push(field);
    }
  }

  return partitions;
}
